import { render, staticRenderFns } from "./Anabel.vue?vue&type=template&id=c891861e&"
import script from "./Anabel.vue?vue&type=script&lang=ts&"
export * from "./Anabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports